import React from "react";
import { Box, Typography } from "@mui/material";
import checkIcon from "../../../../assets/icons/voucher-check-thanks.svg";
import { useSelector } from "react-redux";
import { formatDateIST } from "../common-functions/PaymentCommonFunctions";
import SummaryHeader from "./SummaryHeader";

const ThankYou = () => {
  const { applicantData } = useSelector((state) => state.voucherForm);
  return (
    <Box
      sx={{
        border: "1px solid rgba(26, 64, 125, 0.1)",
        borderRadius: "16px",
        height: {
          xs: "60%",
          sm: "60%",
          md: "60%",
          lg: "10%",
        },
        minHeight: {
          xs: "300px",
          sm: "300px",
          md: "400px",
          lg: "600px",
        },
      }}
      px={2}
      py={3}
      mb={2}
    >
    <SummaryHeader applicantData={applicantData} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "70%", // Ensures it takes all available height from parent
          textAlign: "center",
        }}
      >
        <img
          src={checkIcon}
          alt="check icon"
          style={{ marginBottom: "24px" }}
        />
        <Typography variant="body2" sx={{ fontWeight: 600 }} mb={1}>
          Thank you,{" "}
          {`${applicantData?.applicant1?.personalDetails?.firstName}
              ${applicantData?.applicant1?.personalDetails?.lastName}`}
        </Typography>
        <Typography mb={1} sx={{ fontSize: '12px' }}>
          Your  {applicantData?.formPhase === 'EOI' ? 'EOI' : 'Voucher'} for {applicantData?.campaignName} has been submitted
          successfully
        </Typography>
        <Box
          sx={{
            display: "inline-block",
            backgroundColor: "rgba(0, 184, 217, 0.08)",
            px: "12px",
            py: "6px",
            borderRadius: "8px",
          }}
        >
          <Typography
            sx={{
              color: "rgba(0, 108, 156, 1)",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            Unique Reference ID: {applicantData?.uniqueReferenceId ?? "-"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ThankYou;